__turbopack_context__.v({
  "backToTop": "style-module-scss-module__620htq__backToTop",
  "copyRight": "style-module-scss-module__620htq__copyRight",
  "footer": "style-module-scss-module__620htq__footer",
});
